import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types'
import { ApiResult, throwApiError } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'

export interface InstallationPowerPriceDto {
  from: string
  price: string
  weekday: string
  start: string
  end: string
}

export type InstallationPowerPricePOSTDto = Pick<InstallationPowerPriceDto, 'from' | 'price' | 'weekday'>[]

export const getPowerBuyPrices = async (
  installationId: number,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<ArrayType<Nullable<InstallationPowerPriceDto>> | null>> => {
  try {
    const response = await authFetch<ArrayType<Nullable<InstallationPowerPriceDto>>>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/power-buy-price`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<ArrayType<Nullable<InstallationPowerPriceDto>>>(response.data)
  } catch (error) {
    return throwApiError(error, 'Failed to get power buy prices:')
  }
}

export const updatePowerBuyPrices = async (
  installationId: number,
  prices: InstallationPowerPricePOSTDto,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null>> => {
  try {
    const response = await authFetch({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/power-buy-price`,
      method: 'POST',
      payload: prices,
    })

    if (response.status !== StatusCodes.OK && response.status !== StatusCodes.CREATED) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<null>(null)
  } catch (error) {
    return throwApiError(error, 'Failed to update power buy prices:')
  }
}

export const getPowerSellPrices = async (
  installationId: number,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<ArrayType<Nullable<InstallationPowerPriceDto>> | null>> => {
  try {
    const response = await authFetch<ArrayType<Nullable<InstallationPowerPriceDto>>>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/power-sell-price`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<ArrayType<Nullable<InstallationPowerPriceDto>>>(response.data)
  } catch (error) {
    return throwApiError(error, 'Failed to get power sell prices:')
  }
}

export const updatePowerSellPrices = async (
  installationId: number,
  prices: InstallationPowerPricePOSTDto,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null>> => {
  try {
    const response = await authFetch({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/power-sell-price`,
      method: 'POST',
      payload: prices,
    })

    if (response.status !== StatusCodes.OK && response.status !== StatusCodes.CREATED) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<null>(null)
  } catch (error) {
    return throwApiError(error, 'Failed to update power sell prices:')
  }
}
